import {
  __spreadProps,
  __spreadValues
} from "../chunk-FDX44TNG.js";
import { serializeObjectForHttpHeader } from "@srgssr/rio-shared";
import { envDevelopment } from "../env/development.js";
import { envProduction } from "../env/production.js";
import envVarGenerated from "../generated/envExtra.json";
const ENV_VARS = (() => {
  const envVars = {
    env: "",
    apolloClientUrl: "",
    eventGatewayUrl: "",
    eventGatewaySubscriptionKey: "",
    webBaseUrl: "",
    apiVersion: "",
    remoteConfigUrl: "",
    geoApiUrl: "",
    staticBucketUrl: "",
    extra: { buildId: "" },
    hotjarId: void 0,
    hotjarVersion: void 0,
    npawAccountCode: ""
  };
  let envVarFromConfig = null;
  switch (process.env.NODE_ENV) {
    case "production": {
      envVarFromConfig = envProduction;
      break;
    }
    default: {
      envVarFromConfig = envDevelopment;
      break;
    }
  }
  if (envVarFromConfig) {
    envVars.env = envVarFromConfig.REACT_APP_ENV;
    envVars.apolloClientUrl = envVarFromConfig.REACT_APP_APOLLO_CLIENT_URL;
    envVars.eventGatewayUrl = envVarFromConfig.REACT_APP_EVENT_GATEWAY_URL;
    envVars.eventGatewaySubscriptionKey = envVarFromConfig.REACT_APP_EVENT_GATEWAY_SUBSCRIPTION_KEY;
    envVars.webBaseUrl = envVarFromConfig.REACT_APP_WEB_BASE_URL;
    envVars.apiVersion = envVarFromConfig.REACT_APP_API_VERSION;
    envVars.remoteConfigUrl = envVarFromConfig.REACT_APP_REMOTE_CONFIG_URL;
    envVars.geoApiUrl = envVarFromConfig.REACT_APP_GEO_API_URL;
    envVars.staticBucketUrl = envVarFromConfig.REACT_APP_STATIC_BUCKET_URL;
    envVars.hotjarId = envVarFromConfig.REACT_APP_HOTJAR_SIDEID;
    envVars.hotjarVersion = envVarFromConfig.REACT_APP_HOTJAR_VERSION;
    envVars.npawAccountCode = envVarFromConfig.REACT_NPAW_ACCOUNT_CODE;
  }
  if (envVarGenerated) {
    envVars.extra = envVarGenerated;
  }
  if (process.env.REACT_APP_ENV && process.env.REACT_APP_ENV !== void 0) {
    envVars.env = process.env.REACT_APP_ENV;
  }
  if (process.env.REACT_APP_APOLLO_CLIENT_URL && process.env.REACT_APP_APOLLO_CLIENT_URL !== void 0) {
    envVars.apolloClientUrl = process.env.REACT_APP_APOLLO_CLIENT_URL;
  }
  if (process.env.REACT_APP_EVENT_GATEWAY_URL && process.env.REACT_APP_EVENT_GATEWAY_URL !== void 0) {
    envVars.eventGatewayUrl = process.env.REACT_APP_EVENT_GATEWAY_URL;
  }
  if (process.env.REACT_APP_EVENT_GATEWAY_SUBSCRIPTION_KEY && process.env.REACT_APP_EVENT_GATEWAY_SUBSCRIPTION_KEY !== void 0) {
    envVars.eventGatewaySubscriptionKey = process.env.REACT_APP_EVENT_GATEWAY_SUBSCRIPTION_KEY;
  }
  if (process.env.REACT_APP_WEB_BASE_URL && process.env.REACT_APP_WEB_BASE_URL !== void 0) {
    envVars.webBaseUrl = process.env.REACT_APP_WEB_BASE_URL;
  }
  if (process.env.REACT_APP_API_VERSION && process.env.REACT_APP_API_VERSION !== void 0) {
    envVars.apiVersion = process.env.REACT_APP_API_VERSION;
  }
  if (process.env.REACT_APP_REMOTE_CONFIG_URL && process.env.REACT_APP_REMOTE_CONFIG_URL !== void 0) {
    envVars.remoteConfigUrl = process.env.REACT_APP_REMOTE_CONFIG_URL;
  }
  if (process.env.REACT_APP_GEO_API_URL && process.env.REACT_APP_GEO_API_URL !== void 0) {
    envVars.geoApiUrl = process.env.REACT_APP_GEO_API_URL;
  }
  if (process.env.REACT_APP_STATIC_BUCKET_URL && process.env.REACT_APP_STATIC_BUCKET_URL !== void 0) {
    envVars.staticBucketUrl = process.env.REACT_APP_STATIC_BUCKET_URL;
  }
  if (process.env.REACT_APP_HOTJAR_SIDEID && process.env.REACT_APP_HOTJAR_SIDEID !== void 0) {
    envVars.hotjarId = parseInt(process.env.REACT_APP_HOTJAR_SIDEID);
  }
  if (process.env.REACT_APP_HOTJAR_VERSION && process.env.REACT_APP_HOTJAR_VERSION !== void 0) {
    envVars.hotjarVersion = parseInt(process.env.REACT_APP_HOTJAR_VERSION);
  }
  if (process.env.REACT_NPAW_ACCOUNT_CODE && process.env.REACT_NPAW_ACCOUNT_CODE !== void 0) {
    envVars.npawAccountCode = process.env.REACT_NPAW_ACCOUNT_CODE;
  }
  return envVars;
})();
const isProductionEnvironment = () => process.env.NODE_ENV === "production";
const isMajorVersionUpdate = (oldVersion, newVersion) => parseInt(oldVersion.split(".")[0]) < parseInt(newVersion.split(".")[0]);
const getVersionString = () => `${ENV_VARS.extra.appVersionName} (${ENV_VARS.extra.appBuildNumber})`;
const getNpawVersionString = () => `${ENV_VARS.extra.appVersionName}_${ENV_VARS.extra.appBuildNumber}`;
const createHeaders = ({
  others,
  platform,
  device,
  idToken,
  profileId,
  locale
}) => {
  const headers = __spreadProps(__spreadValues({}, others), {
    "x-playsuisse-locale": locale
  });
  const app = {
    id: platform,
    version: ENV_VARS.extra.appVersionName
  };
  if (platform !== "web") {
    app.build = ENV_VARS.extra.appBuildNumber;
  }
  headers["x-playsuisse-app"] = serializeObjectForHttpHeader(app);
  if (device)
    headers["x-playsuisse-device"] = serializeObjectForHttpHeader(device);
  if (idToken) {
    headers.authorization = `Bearer ${idToken}`;
    if (profileId)
      headers["x-playsuisse-user-profile-id"] = profileId;
  }
  return headers;
};
export {
  ENV_VARS,
  createHeaders,
  getNpawVersionString,
  getVersionString,
  isMajorVersionUpdate,
  isProductionEnvironment
};
//# sourceMappingURL=env.js.map